import { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { usePreferences } from '../../contexts/PreferencesContext';
import { apiGetUserUiProps, apiPutUserUiProps } from '../../utils/api';
import styles from './UiPropsModal.module.css';

const UiPropsModal = ({ onClose }) => {
  const { token } = useAuth();
  const { updatePreference } = usePreferences(); // ← neu: Context-Funktion holen

  const [uiProps, setUiProps] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const loadUiProps = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiGetUserUiProps(token);
      setUiProps(data.ui_props);
      setEditValue(JSON.stringify(data.ui_props, null, 2));
    } catch (err) {
      setError(err.error || 'Fehler beim Laden');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUiProps();
  }, [token]);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    setSuccess(null);
    try {
      const newProps = JSON.parse(editValue);
      await apiPutUserUiProps(token, newProps);
      setUiProps(newProps);
      setSuccess('Gespeichert!');

      // 🔁 Context mit den neuen Werten für Akzentfarbe & Schriftgröße aktualisieren
      if (newProps.accentColor !== undefined) {
        updatePreference('accentColor', newProps.accentColor);
      }
      if (newProps.fontSize !== undefined) {
        updatePreference('fontSize', newProps.fontSize);
      }

      setTimeout(() => setSuccess(null), 2000);
    } catch (err) {
      if (err instanceof SyntaxError) {
        setError('Ungültiges JSON-Format');
      } else {
        setError(err.error || 'Fehler beim Speichern');
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>UI-Props (Widget‑Konfiguration)</h3>

        {loading && <p>Lade...</p>}
        {error && <p className={styles.error}>{error}</p>}
        {success && <p className={styles.success}>{success}</p>}

        {!loading && (
          <>
            <textarea
              className={styles.jsonEditor}
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              rows={12}
            />
            <div className={styles.buttonGroup}>
              <button
                className={styles.saveBtn}
                onClick={handleSave}
                disabled={saving}
              >
                {saving ? 'Speichern...' : 'Speichern'}
              </button>
              <button className={styles.reloadBtn} onClick={loadUiProps}>
                Neu laden
              </button>
              <button className={styles.closeBtn} onClick={onClose}>
                Schließen
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UiPropsModal;